import { Modal } from "react-responsive-modal";
import homeBg from "../../../assets/images/home-bg.png";
import HomeLogin from "../../../pages/Home/HomeLogin";
import "./LoginModal.css";

const LoginModal = ({ isOpen, onClose, setShowLoginModal ,setShowQuizTypeModal}) => {
  const closeIcon = (
    <svg width="33px" height="33px" viewBox="0 0 24 24" fill="#FFAEC4">
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        fill="#FBAECA"
      />
      <path
        d="M13.0594 12.0001L15.3594 9.70011C15.6494 9.41011 15.6494 8.93011 15.3594 8.64011C15.0694 8.35011 14.5894 8.35011 14.2994 8.64011L11.9994 10.9401L9.69937 8.64011C9.40937 8.35011 8.92937 8.35011 8.63938 8.64011C8.34938 8.93011 8.34938 9.41011 8.63938 9.70011L10.9394 12.0001L8.63938 14.3001C8.34938 14.5901 8.34938 15.0701 8.63938 15.3601C8.78938 15.5101 8.97937 15.5801 9.16937 15.5801C9.35937 15.5801 9.54937 15.5101 9.69937 15.3601L11.9994 13.0601L14.2994 15.3601C14.4494 15.5101 14.6394 15.5801 14.8294 15.5801C15.0194 15.5801 15.2094 15.5101 15.3594 15.3601C15.6494 15.0701 15.6494 14.5901 15.3594 14.3001L13.0594 12.0001Z"
        fill="#000000"
      />
    </svg>
  );
  return (
    <Modal
      closeIcon={closeIcon}
      classNames={{ modal: "custom-modal" }}
      open={isOpen}
      onClose={onClose}
      center
      focusTrapped={false}
    >
      <div
        style={{
          backgroundImage: `url('${homeBg}')`,
          backgroundSize: "contain",
          backgroundPosition: "center",
        }}
        className="relative px-5 pt-12 pb-10 flex flex-col justify-center items-center gap-6 md:gap-8"
      >
        <HomeLogin
          isHome={false}
          setShowLoginModal={setShowLoginModal}
          setShowQuizTypeModal={setShowQuizTypeModal}
          inputFlexDir="col"
        />
      </div>
    </Modal>
  );
};
export default LoginModal;
